import { motion } from "framer-motion";
import { FaDiscord, FaXTwitter, FaInstagram } from "react-icons/fa6";
import { SiKick } from "react-icons/si";
import { EASE } from "@/lib/site";

const SOCIALS = [
  { id: "discord", label: "Join the Discord", handle: "discord.gg/fwSDeNYSGB", href: "https://discord.gg/fwSDeNYSGB", Icon: FaDiscord },
  { id: "kick", label: "Follow me on Kick", handle: "kick.com/dafaber", href: "https://kick.com/dafaber", Icon: SiKick },
  { id: "x", label: "Follow me on X", handle: "@dafaber", href: "https://x.com/dafaber", Icon: FaXTwitter },
  { id: "instagram", label: "Follow me on Instagram", handle: "@dafaber_", href: "https://www.instagram.com/dafaber_/", Icon: FaInstagram },
];

export const Footer = () => (
  <footer id="socials" className="footer px-5 pb-10 pt-24 sm:px-8 lg:px-12" data-testid="site-footer">
    <div className="mx-auto max-w-7xl">
      <p className="eyebrow">Socials</p>
      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SOCIALS.map(({ id, label, handle, href, Icon }, i) => (
          <motion.a
            key={id} href={href} target="_blank" rel="noopener noreferrer"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
            className={`social-card social-${id}`} data-testid={`footer-social-${id}`}
          >
            <span className="social-icon"><Icon className="h-6 w-6" /></span>
            <span className="mt-8 block font-display text-xl font-extrabold">{label}</span>
            <span className="mt-1 block text-sm opacity-90">{handle}</span>
          </motion.a>
        ))}
      </div>

      <div className="footer-word font-display" aria-hidden>DAFABER</div>

      <div className="flex flex-col gap-4 border-t border-white/15 pt-6 text-sm text-white/80 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Dafaber. All rights reserved.</p>
        <p data-testid="footer-disclaimer">18+ only. Gamble responsibly. Play only with what you can afford to lose.</p>
      </div>
    </div>
  </footer>
);
